import {
  GET_NORMSLIBRARY,
  GET_NORMSLIBRARY_FAIL,
  GET_NORMSLIBRARY_SUCCESS,
  GET_NORMSLIBRARYS,
  GET_NORMSLIBRARYS_FAIL,
  GET_NORMSLIBRARYS_SUCCESS,
  ADD_NEW_NORMSLIBRARY,
  ADD_NORMSLIBRARY_SUCCESS,
  ADD_NORMSLIBRARY_FAIL,
  UPDATE_NORMSLIBRARY,
  UPDATE_NORMSLIBRARY_SUCCESS,
  UPDATE_NORMSLIBRARY_FAIL,
  DELETE_NORMSLIBRARY,
  DELETE_NORMSLIBRARY_SUCCESS,
  DELETE_NORMSLIBRARY_FAIL,
  SET_STATE_NORMSLIBRARY
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_NORMSLIBRARY,
  payload: loading,
})

export const getNormsLibrarys = ( params ) => ({
  type: GET_NORMSLIBRARYS,
  payload: { params },
})

export const getNormsLibrarysSuccess = (normsLibrarys, totalPages, currentPage) => ({
  type: GET_NORMSLIBRARYS_SUCCESS,
  payload: { normsLibrarys:normsLibrarys, total:totalPages, currentPage:currentPage}
})

export const getNormsLibrarysFail = error => ({
  type: GET_NORMSLIBRARYS_FAIL,
  payload: error,
})

export const addNewNormsLibrary = normsLibrary => ({
  type: ADD_NEW_NORMSLIBRARY,
  payload: normsLibrary,
})

export const addNormsLibrarySuccess = normsLibrary => ({
  type: ADD_NORMSLIBRARY_SUCCESS,
  payload: normsLibrary,
})  

export const addNormsLibraryFail = error => ({
  type: ADD_NORMSLIBRARY_FAIL,
  payload: error,
})

export const updateNormsLibrary = normsLibrary => ({
  type: UPDATE_NORMSLIBRARY,
  payload: normsLibrary,
})

export const updateNormsLibrarySuccess = normsLibrary => ({
  type: UPDATE_NORMSLIBRARY_SUCCESS,
  payload: normsLibrary,
})

export const updateNormsLibraryFail = error => ({
  type: UPDATE_NORMSLIBRARY_FAIL,
  payload: error,
})

export const deleteNormsLibrary = normsLibrary => ({
  type: DELETE_NORMSLIBRARY,
  payload: normsLibrary,
})

export const deleteNormsLibrarySuccess = id => ({
  type: DELETE_NORMSLIBRARY_SUCCESS,
  id,
})

export const deleteNormsLibraryFail = error => ({
  type: DELETE_NORMSLIBRARY_FAIL,
  payload: error,
})

export const getNormsLibrary = () => ({
  type: GET_NORMSLIBRARY,
})

export const getNormsLibrarySuccess = normsLibrary => ({
  type: GET_NORMSLIBRARY_SUCCESS,
  payload: normsLibrary,
})

export const getNormsLibraryFail = error => ({
  type: GET_NORMSLIBRARY_FAIL,
  payload: error,
})
